import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_headphone",
  "use": "icon-project_headphone-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_headphone\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M26 14c0-6.627-5.373-12-12-12S2 7.373 2 14\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 26h6v-9H2M26 26h-6v-9h6\" /><path d=\"M2 14v12M26 14v12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol